<template>

    <!-- TW Snippet Start v2.0+ -->
    <div class="bg-gray-900" :id="$props.id">
        <div class="pt-12 px-4 sm:px-6 lg:px-8 lg:pt-20">
            <div class="text-center">
                <h2 class="text-lg leading-6 font-semibold text-gray-300 uppercase tracking-wider">
                    Ceník
                </h2>
                <p class="mt-0 max-w-4xl mx-auto text-xl text-gray-300 sm:text-2xl">
                    Nevyhovuje Vám žádná z nabídek? <a target="_blank" href="mailto:info@dschranka.cz" class="underline">Napište nám</a> a vymyslíme řešení na míru!
                </p>
            </div>
        </div>

        <div class="mt-8 bg-white pb-12 lg:mt-12 lg:pb-20">
            <div class="relative z-0">
                <div class="absolute inset-0 h-5/6 bg-gray-900 lg:h-2/3"></div>
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="relative lg:grid lg:grid-cols-7">
                        <div v-if="plans.length > 1" class="mx-auto max-w-md lg:mx-0 lg:max-w-none lg:col-start-1 lg:col-end-3 lg:row-start-2 lg:row-end-3">
                            <div class="h-full flex flex-col rounded-lg shadow-lg overflow-hidden lg:rounded-none lg:rounded-l-lg">
                                <div class="flex-1 flex flex-col">
                                    <div class="bg-white px-6 py-10">
                                        <div>
                                            <h3 class="text-center text-2xl font-medium text-gray-900" id="tier-hobby">
                                                {{ plans[0].name }}
                                            </h3>
                                            <div class="mt-4 flex items-center justify-center">
                                                <span class="px-3 flex items-start text-6xl tracking-tight text-gray-900">
                                                  <span class="mt-2 mr-2 text-4xl font-medium">
                                                      CZK
                                                  </span>
                                                  <span class="font-extrabold">
                                                    {{ plans[0].monthlyPrice / 100 }}
                                                  </span>
                                                </span>
                                                <span class="text-xl font-medium text-gray-500">
                                                    /měsíc
                                                </span>
                                            </div>

                                            <div class="flex items-center justify-center">
                                                <span class="px-1 flex items-start tracking-tight text-gray-900">
                                                    <span class="mr-1 font-medium">
                                                        nebo CZK
                                                    </span>
                                                    <span class="font-bold">
                                                        {{ plans[0].yearlyPrice / 100 }}
                                                    </span>
                                                </span>
                                                <span class="font-medium text-gray-500">
                                                    /rok
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10">
                                        <ul class="space-y-4">
                                            <li v-for="feature in plans[0].features" class="flex items-start">
                                                <div class="shrink-0">
                                                    <!-- Heroicon name: outline/check -->
                                                    <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                                <p class="ml-3 text-base font-medium text-gray-500">
                                                    {{ feature }}
                                                </p>
                                            </li>
                                        </ul>
                                        <div class="mt-8">
                                            <div class="rounded-lg shadow-md">
                                                <a :href="route('register', {p: plans[0].id, code: code})" class="block w-full text-center rounded-lg border border-transparent bg-white px-6 py-3 text-base font-medium text-indigo-600 hover:bg-gray-50" aria-describedby="tier-hobby">
                                                    Vyzkoušet zdarma
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-10 max-w-lg mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-start-3 lg:col-end-6 lg:row-start-1 lg:row-end-4">
                            <div class="relative z-10 rounded-lg shadow-xl">
                                <div class="pointer-events-none absolute inset-0 rounded-lg border-2 border-indigo-600" aria-hidden="true"></div>
                                <div class="absolute inset-x-0 top-0 transform translate-y-px">
                                    <div class="flex justify-center transform -translate-y-1/2">
                                        <span class="inline-flex rounded-full bg-indigo-600 px-4 py-1 text-sm font-semibold tracking-wider uppercase text-white">
                                          Doporučujeme
                                        </span>
                                    </div>
                                </div>
                                <div class="bg-white rounded-t-lg px-6 pt-12 pb-10">
                                    <div>
                                        <h3 class="text-center text-3xl font-semibold text-gray-900 sm:-mx-6" id="tier-growth">
                                            {{ plans[2].name }}
                                        </h3>
                                        <div class="mt-4 flex items-center justify-center">
                                            <span class="px-3 flex items-start text-6xl tracking-tight text-gray-900 sm:text-6xl">
                                              <span class="mt-2 mr-2 text-4xl font-medium">
                                                CZK
                                              </span>
                                              <span class="font-extrabold">
                                                {{ plans[2].monthlyPrice / 100 }}
                                              </span>
                                            </span>
                                            <span class="text-2xl font-medium text-gray-500">
                                                /měsíc
                                            </span>
                                        </div>
                                        <div class="flex items-center justify-center">
                                            <span class="px-1 flex items-start tracking-tight text-gray-900">
                                                <span class="mr-1 font-medium">
                                                    nebo CZK
                                                </span>
                                                <span class="font-bold">
                                                    {{ plans[2].yearlyPrice / 100 }}
                                                </span>
                                            </span>
                                            <span class="font-medium text-gray-500">
                                                /rok
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-t-2 border-gray-100 rounded-b-lg pt-10 pb-8 px-6 bg-gray-50 sm:px-10 sm:py-10">
                                    <ul class="space-y-4">

                                        <li v-for="feature in plans[2].features" class="flex items-start">
                                            <div class="shrink-0">
                                                <!-- Heroicon name: outline/check -->
                                                <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                                </svg>
                                            </div>
                                            <p class="ml-3 text-base font-medium text-gray-500">
                                                {{ feature }}
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="mt-10">
                                        <div class="rounded-lg shadow-md">
                                            <a :href="route('register', {p: plans[2].id, code: code})" class="block w-full text-center rounded-lg border border-transparent bg-indigo-600 px-6 py-4 text-xl leading-6 font-medium text-white hover:bg-indigo-700" aria-describedby="tier-growth">
                                                Vyzkoušet zdarma
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="plans.length > 2" class="mt-10 mx-auto max-w-md lg:m-0 lg:max-w-none lg:col-start-6 lg:col-end-8 lg:row-start-2 lg:row-end-3">
                            <div class="h-full flex flex-col rounded-lg shadow-lg overflow-hidden lg:rounded-none lg:rounded-r-lg">
                                <div class="flex-1 flex flex-col">
                                    <div class="bg-white px-6 py-10">
                                        <div>
                                            <h3 class="text-center text-2xl font-medium text-gray-900" id="tier-scale">
                                                {{ plans[1].name }}
                                            </h3>
                                            <div class="mt-4 flex items-center justify-center">
                                                <span class="px-3 flex items-start text-6xl tracking-tight text-gray-900">
                                                  <span class="mt-2 mr-2 text-4xl font-medium">
                                                      CZK
                                                  </span>
                                                  <span class="font-extrabold">
                                                      {{ plans[1].monthlyPrice / 100 }}
                                                  </span>
                                                </span>
                                                <span class="text-xl font-medium text-gray-500">
                                                    /měsíc
                                                </span>
                                            </div>
                                            <div class="flex items-center justify-center">
                                                <span class="px-1 flex items-start tracking-tight text-gray-900">
                                                    <span class="mr-1 font-medium">
                                                        nebo CZK
                                                    </span>
                                                    <span class="font-bold">
                                                        {{ plans[1].yearlyPrice / 100 }}
                                                    </span>
                                                </span>
                                                <span class="font-medium text-gray-500">
                                                    /rok
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10">
                                        <ul class="space-y-4">
                                            <li v-for="feature in plans[1].features" class="flex items-start">
                                                <div class="shrink-0">
                                                    <!-- Heroicon name: outline/check -->
                                                    <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                                <p class="ml-3 text-base font-medium text-gray-500">
                                                    {{ feature }}
                                                </p>
                                            </li>
                                        </ul>
                                        <div class="mt-8">
                                            <div class="rounded-lg shadow-md">
                                                <a :href="route('register', {p: plans[1].id, code: code})" class="block w-full text-center rounded-lg border border-transparent bg-white px-6 py-3 text-base font-medium text-indigo-600 hover:bg-gray-50" aria-describedby="tier-scale">
                                                    Vyzkoušet zdarma
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "Pricing",
    data() {
        return {
            plans: this.$page.props.plans,
            code: this.$page.props.code,
        }
    },
    methods: {

    }

}
</script>

<style scoped>

</style>
